import React, { useEffect } from 'react';
import './index.scss';
import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import { getCardAnimation, getTarget } from '../common';

interface Props {
    prefixCls: string;
    item: any;
    title: string;
    isService: boolean;
}

const CardTypeB: React.FC<Props> = ({ prefixCls, item, title, isService }) => {
    const lItems = item.subs || [];

    let rItems: any[] = [];
    try {
        const extJson = item?.extJson;
        if (extJson && extJson.trim() !== '') {
            rItems = JSON.parse(extJson);
        } else {
            rItems = [];
        }
    } catch (e) {
        rItems = [];
    }

    useEffect(() => {
        if (typeof window === 'undefined') return;
        const content = document.querySelector('.ef-header-v2-nav-list__dropdown');
        if (content) {
            content.scrollTop = 0;
        }
    }, []);

    if (lItems.length === 0) return <div className={`${prefixCls}-card-type-b`}></div>;
    return (
        <div className={`${prefixCls}-card-type-b`}>
            <div className={`${prefixCls}-card-type-b__grid`}>
                {lItems?.map?.((i: any, idx: number) => (
                    <EcoLink
                        className={`${prefixCls}-card-type-b__grid-item type-b-l-i-${idx} GtmModuleData-btn-href`}
                        style={{
                            animation: getCardAnimation(idx),
                        }}
                        href={i.url}
                        target={getTarget(i.url)}
                        dataLayer={{
                            ...(isService
                                ? {
                                      event_name: 'support_navigation',
                                      navigation_name: i.heading,
                                  }
                                : {
                                      event_name: 'view_more',
                                      list_name: title,
                                      button_name: i.heading,
                                  }),
                            position: 'Homepage_navigation',
                            navigation_name: `${title}`,

                            __btn_id1: `type-b-l-i-${idx}`,
                            __btn_id2: i.url,
                            __btn_type: 'href',
                        }}
                        key={i.id || idx}
                    >
                        <EcoImg className={`${prefixCls}-card-type-b__item-img`} pc={i.pictureUrl} />
                        <div className={`${prefixCls}-card-type-b__item-title`}>
                            <span>{i.heading}</span>
                        </div>
                    </EcoLink>
                ))}
            </div>
            <ul className={`${prefixCls}-card-type-b__right`}>
                {rItems?.map((i: any, idx: number) => (
                    <li
                        className={`${prefixCls}-card-type-b__right-item`}
                        style={{
                            animation: getCardAnimation(idx, lItems?.length),
                        }}
                        key={i.updateTime || idx}
                    >
                        <EcoLink
                            className={`${prefixCls}-card-type-b__right-item-link type-b-r-i-${idx}`}
                            href={i.url}
                            target={getTarget(i.url)}
                            dataLayer={{
                                ...(isService
                                    ? {
                                          event_name: 'support_navigation',
                                          navigation_name: i.heading,
                                      }
                                    : {
                                          event_name: 'view_more',
                                          list_name: title,
                                          button_name: i.heading,
                                      }),
                                position: 'Homepage_navigation',
                                navigation_name: `${title}`,

                                __btn_id1: `type-b-r-i-${idx}`,
                                __btn_id2: i.url,
                                __btn_type: 'href',
                            }}
                        >
                            <EcoImg className={`${prefixCls}-card-type-b__right-item-icon`} pc={i.pictureUrl} />
                            <span className={`${prefixCls}-card-type-b__right-item-text`}>{i.name}</span>
                        </EcoLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};
export default CardTypeB;
